import { Button } from 'antd';
import styled from 'styled-components';

export const TransparentButton = styled(Button)`
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
